import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { WhatsAppNotificationService } from "@gtpl/shared-services/notification-management";
import { WhatsappBroadCastService } from "@gtpl/shared-services/whatsapp-broad-cast";
import { AssetsSale } from "./entity/asset-sale.entity";
import { AssetsSalesController } from "./asset-sale.controller";
import { AssetsSaleService } from "./asset-sale.service";
import { AssetsSaleAdapter } from "./entity/asset-sale.adapter";
import { AssetTransaction } from "../open-assets/asset-transaction-entity";
import { AssetsRepository } from "../open-assets/dto/opens-assets-repository";
import { AssetsModule } from "../open-assets/open-assets.module";
import { AssetTransactionAdapter } from "../open-assets/dto/asset-transaction-adapter";

@Module({
    imports: [
        TypeOrmModule.forFeature([AssetsSale,AssetTransaction,AssetsRepository]),
        AssetsModule
    ],
    controllers: [AssetsSalesController],
    providers: [AssetsSaleService,ApplicationExceptionHandler,WhatsAppNotificationService,WhatsappBroadCastService,AssetsSaleAdapter,AssetTransactionAdapter],
    exports:[TypeOrmModule],
})

export class AssetsSaleModule{}